import { ReactNode } from 'react'

import { Image } from '../common/components/Image.js'

export const UpgradeBanner = ({ children }: { children: ReactNode }) => {
  return (
    <div className="bg-decorative-surface-5 text-decorative-content-5 rounded-lg p-2 flex space-s-3 items-center">
      <div className="rounded-lg p-2">
        <Image
          src="/images/icons/upgrade-icon.svg"
          alt="Upgrade plan icon"
          className="w-6 h-6 flex-shrink-0"
        />
      </div>
      <div className="flex-grow">{children}</div>
    </div>
  )
}
